import AfipLogo from './AfipLogo';
export default AfipLogo;
